import { AxiosResponse } from 'axios';
import { BASE_URL } from '../config/api';
import client from './client';
import {
    CreateLiveCouponBody,
    AddNormalCouponsToLsBroadcastResponse,
    GetLsBroadcastNormalCouponsResponse,
    LsBroadcastSettingCouponsResponse,
} from 'src/admin-entity/interface/coupon2/coupon2-ls-broadcast-setting.interface';
import { GetAppliedCouponsResponse } from 'src/admin-entity/interface/coupon2/coupon2-applied.interface';
import {
    AppUserCouponListResponse,
    CouponDetail,
    CouponListResponse,
} from 'src/admin-entity/interface/coupon2/coupon2-list.interface';
import {
    GetCouponZoneDetailResponse,
    GetCouponZoneListResponse,
} from 'src/admin-entity/interface/coupon2/coupon2-zone.interface';
import { RemainPriceInfo } from 'src/admin-entity/interface/payment/remain-price.interface';
import {
    CreateLiveEventCouponBody,
    GetEventCouponsResponse,
} from 'src/admin-entity/interface/coupon2/coupon2-event.interface';

// 쿠폰
export const createCoupon2 = (data: any): Promise<AxiosResponse<any>> =>
    client.post(`${BASE_URL}/v1/admin/coupon`, data);

export const getCouponList2 = (params: {
    page: number;
    take: number;
    name?: string;
    couponType?: string;
    couponIssueTypes?: string;
    couponIssueStatus?: string;
    couponIssueStatusMulti?: string;
}): Promise<AxiosResponse<CouponListResponse>> => client.get(`${BASE_URL}/v1/admin/coupon`, { params });

export const getCouponDetail2 = (couponId: number): Promise<AxiosResponse<CouponDetail>> =>
    client.get(`${BASE_URL}/v1/admin/coupon/${couponId}`);

export const updateCoupon2 = (couponId: number, data: any): Promise<AxiosResponse<any>> =>
    client.put(`${BASE_URL}/v1/admin/coupon/${couponId}`, data);

export const endCouponIssue = (couponId: number): Promise<AxiosResponse<any>> =>
    client.post(`${BASE_URL}/v1/admin/coupon/${couponId}/issue-ended`);

export const revokeCoupon = (couponId: number): Promise<AxiosResponse<any>> =>
    client.post(`${BASE_URL}/v1/admin/coupon/${couponId}/revoke`);

export const issueCouponToUser = (couponId: number, appUserId: number): Promise<AxiosResponse<any>> =>
    client.post(`${BASE_URL}/v1/admin/coupon/${couponId}/appUser/${appUserId}/issue`);

// 쿠폰 로그
export const getCouponLogList = (couponId: number): Promise<AxiosResponse<any>> =>
    client.get(`${BASE_URL}/v1/admin/coupon/${couponId}/log`);

// 회원 쿠폰
export const getAppUserCouponList = (params: {
    page: number;
    take: number;
    appUserId?: number;
}): Promise<AxiosResponse<AppUserCouponListResponse>> => client.get(`${BASE_URL}/v1/admin/app-user-coupon`, { params });

export const revokeAppUserCoupon = (appUserCouponId: number): Promise<AxiosResponse<any>> =>
    client.delete(`${BASE_URL}/v1/admin/app-user-coupon/${appUserCouponId}/revoke`);

// 쿠폰존
export const createCouponZone = (data: any): Promise<AxiosResponse<any>> =>
    client.post(`${BASE_URL}/v1/admin/coupon-zone`, data);

export const getCouponZoneList = (params?: {
    couponName?: string;
    couponZoneDisplayStatus?: string;
}): Promise<AxiosResponse<GetCouponZoneListResponse>> => client.get(`${BASE_URL}/v1/admin/coupon-zone`, { params });

export const getCouponZoneDetail = (couponZoneId: number): Promise<AxiosResponse<GetCouponZoneDetailResponse>> =>
    client.get(`${BASE_URL}/v1/admin/coupon-zone/${couponZoneId}`);

export const updateCouponZone = (couponZoneId: number, data: any): Promise<AxiosResponse<any>> =>
    client.put(`${BASE_URL}/v1/admin/coupon-zone/${couponZoneId}`, data);

export const deleteCouponZone = (couponZoneId: number): Promise<AxiosResponse<any>> =>
    client.delete(`${BASE_URL}/v1/admin/coupon-zone/${couponZoneId}`);

// 라이브 방송 > 설정 > 쿠폰 설정
export const getLsBroadcastSettingCoupons = (
    lsBroadcastId: number,
): Promise<AxiosResponse<LsBroadcastSettingCouponsResponse>> =>
    client.get(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/settings/coupons`);

export const createLiveCoupon = (
    lsBroadcastId: number,
    data: CreateLiveCouponBody,
): Promise<AxiosResponse<LsBroadcastSettingCouponsResponse>> =>
    client.post(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/settings/coupons/live`, data);

export const addCouponToLsBroadcast = (
    lsBroadcastId: number,
    data: { couponIds: number[] },
): Promise<AxiosResponse<LsBroadcastSettingCouponsResponse>> =>
    client.post(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/settings/coupons`, data);

export const updateLsBroadcastCouponVisibility = (
    lsBroadcastId: number,
    data: { couponId: number; isVisible: boolean },
): Promise<AxiosResponse> => client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/settings/coupons/visibility`, data);

// libs/CouponBox에서 참조하지만 어드민에서는 사용하지 않으므로 빈 응답 반환
export const getMyCoupons = (_userId: number): Promise<{ data: { myCoupons: any[] } }> =>
    Promise.resolve({ data: { myCoupons: [] } });

// 주문서의 쿠폰 내역
export const getAppliedCoupons = (orderItemId: number): Promise<AxiosResponse<GetAppliedCouponsResponse>> =>
    client.get(`${BASE_URL}/v1/admin/order-items/${orderItemId}/coupon`);

// 주문서의 쿠폰 재발급
export const reissueAppliedCoupons = (
    orderItemId: number,
    data: { appUserCouponId: number },
): Promise<AxiosResponse<RemainPriceInfo>> =>
    client.post(`${BASE_URL}/v1/admin/order-items/${orderItemId}/coupon/reissue`, data);

// 라이브 내 쿠폰 사용 on/off
export const setLiveCouponUsage = (lsBroadcastId: number, isCouponUsable: boolean): Promise<AxiosResponse<any>> =>
    client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/settings/coupon-usable`, { isCouponUsable });

// 라이브방송 > 쿠폰 > 이벤트 쿠폰
export const getEventCoupons = (lsBroadcastId: number): Promise<AxiosResponse<GetEventCouponsResponse>> =>
    client.get(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/event-coupon`);

// 라이브방송 > 쿠폰 > 쿠폰 사용 가능 여부 설정
export const setEventCouponUsable = (
    lsBroadcastId: number,
    data: {
        isCouponUsable: boolean;
    },
): Promise<AxiosResponse<GetEventCouponsResponse>> =>
    client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/event-coupon/usable`, data);

// 라이브방송 > 쿠폰 > 라이브 쿠폰 사용 설정
export const setLiveEventCouponUsable = (
    lsBroadcastId: number,
    couponId: number,
    data: { isUsable: boolean },
): Promise<AxiosResponse<GetEventCouponsResponse>> =>
    client.put(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/event-coupon/${couponId}/usable`, data);

// 라이브방송 > 쿠폰 > 라이브 쿠폰 즉시 생성
export const createLiveEventCoupon = (
    lsBroadcastId: number,
    data: CreateLiveEventCouponBody,
): Promise<AxiosResponse<GetEventCouponsResponse>> =>
    client.post(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/event-coupon/live`, data);

// 라이브방송 > 쿠폰 > 기존 일반 쿠폰 추가 > 기존 일반 쿠폰 리스트
export const getLsBroadcastNormalCoupons = (
    lsBroadcastId: number,
): Promise<AxiosResponse<GetLsBroadcastNormalCouponsResponse>> =>
    client.get(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/coupon`);

// 라이브방송 > 쿠폰 > 기존 일반 쿠폰 추가
export const addNormalCouponsToLsBroadcast = (
    lsBroadcastId: number,
    data: { couponIds: number[] },
): Promise<AxiosResponse<AddNormalCouponsToLsBroadcastResponse>> =>
    client.post(`${BASE_URL}/v1/admin/ls/${lsBroadcastId}/coupon`, data);

// 쿠폰 > TEST > TEST-쿠폰검증 초기화
export const resetCouponValidation = (appUserId: number): Promise<AxiosResponse<any>> =>
    client.post(`${BASE_URL}/v1/admin/app-users/${appUserId}/reset-coupon-validation`);

// libs/EventCouponBox에서 참조하지만 어드민에서는 사용하지 않으므로 빈 응답 반환
export const getLsEventCoupons = (_lsBroadcastId: number): Promise<{ data: GetEventCouponsResponse }> =>
    Promise.resolve({ data: { isCouponUsable: false, liveCoupons: [], autoCoupons: [] } });

export const doneInviteCoupon = (inviteKey?: string): Promise<AxiosResponse> =>
    client.post(`${BASE_URL}/v1/invite/event-coupon`, inviteKey ? { inviteKey } : undefined);
